import { createSlice, type Draft, type PayloadAction } from '@reduxjs/toolkit';

import { LOADING } from '@ezugi/constants';
import { GenericStateType } from '@ezugi/types';
import { RoundStatus } from '@ezugi/types/src/round';

export type RoundSetAction = {
  type: typeof roundSlice.actions.set;
  payload: Partial<Round>;
};

export type WinnerListEntry = {
  OperatorID: string;
  WinAmount: number;
  Nickname: string;
}

export type RetailRoundStateType = {
  tvRoundNumber?: number;
  messageTimestamp?: number;
  winningBalls?: number[];
};

export type ThreeCardPokerRound = {
  firstCardHands?: GenericStateType;
};

/* TODO:
  Remove `RetailRoundStateType`, `ThreeCardPokerRound` and
  extend through the generic, maybe createStore for each game
  This type should be a BaseRound with common properties
 */
export type Round<T = GenericStateType> = T &
  RetailRoundStateType &
  ThreeCardPokerRound & {
  roundId?: number;
  isShuffleTime: boolean;
  cardReceived: boolean;
  roundStatus: RoundStatus;
  gameResults?: GenericStateType;
  timeLeft?: number;
  totalTime?: number;
  roundStartTimestamp?: number;
  roundTime?: number;
  canPlaceBets?: boolean;
  time?: number;
  timer?: number;
  timerStartTimestamp?: number;
  timestamp?: string;

  winAmount?: number;
  isWinner?: boolean;
  winnerList?: WinnerListEntry[];
  shouldCelebrate?: boolean;
};

export const initialState: Round = {
  roundStatus: LOADING,
  isShuffleTime: false,
  cardReceived: false,
};

export const setPrepare = <T>(payload: T, meta?: Record<string, unknown>) => {
  const enhancedMeta = {
    ...meta,
    spriteName: 'base_sprite',
    soundName: null,
  };

  return { payload, meta: enhancedMeta };
};

export const setReducer = <T extends Round>(
  state: Draft<T>,
  { payload }: PayloadAction<Partial<T>>
) => ({
    ...state,
    ...payload,
  });

export const roundSlice = createSlice({
  name: 'round',
  initialState,
  reducers: {
    set: {
      reducer: setReducer,
      prepare: setPrepare<Partial<Round>>,
    },
  },
});

export const roundActions = roundSlice.actions;
export default roundSlice.reducer;
